// const ONE_MB_IN_BINARY = 1024 * 1024
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export const ONE_MB_IN_DECIMAL = 1000 * 1000
export const TEN_MB = ONE_MB_IN_DECIMAL * 10
export const TWENTY_FIVE_MB = ONE_MB_IN_DECIMAL * 25

export const PAGE_SIZE = 20

/**
 * Set to 200 to make sure we cover the biggest sale ever.
 * The avg sale has 4 items, and the biggest sale had 131 items.
 */
export const SALE_LINES_PAGE_SIZE = 200

export const NOT_FOUND_INDEX = -1
